import {gsap} from "gsap";
import {HTH} from "../HTH";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {HTHGameAssets} from "../HTHGameAssets";
import {ISymbolData, HTHSymbol, HTHSymbolStates} from "./HTHSymbol";
import {HTHHelper} from "../utils/HTHHelper";

export class HTHRemovalSymbol extends HTHSymbol {

    public multiplierText: PIXI.BitmapText;

    private _spineContainer:PIXI.Container;
    private _bg:PIXI.Sprite;
    private _frame:PIXI.Sprite;
    private _spine: PIXI.spine.Spine;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.NORMAL) {
        super(symbolData, state);
        this.symbolState = HTHSymbolStates.NORMAL;
        this.addSpine();
        // this.playSpineAnim("normal");
        this.symSize = 0;
        this.addSymbolMultiplier();
    }

    public get spine(): PIXI.spine.Spine {
        return this._spine;
    }

    public explode(): gsap.core.Timeline {
        const winExplodeTl: gsap.core.Timeline = gsap.timeline();
        return winExplodeTl;
    }

    public playSpineAnim(animName: string): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(HTHHelper.playSpineWithTimeline(this._spine, 0, animName))
        return tl;
    }

    public removalExplode(): gsap.core.Timeline {
        const remExTL: gsap.core.Timeline = gsap.timeline(),
            remWildAnim: TimelineSprite = this.getRemBlastAnim();
        remExTL.add(<gsap.core.Timeline><unknown>remWildAnim.getAnimationAutoShowHide());
        remExTL.to(this, {alpha: 0, duration: remWildAnim.totalDuration / 5}, `>-${remWildAnim.totalDuration / 5}`);
        remExTL.add(() => {
            if (this) {
                if (!this.isEnhancerSymbol) {
                    this.removeAndDestroy();
                }
            }
        }, ">");
        return remExTL;
    }

    public removeAndDestroy(): void {
        if (this.multiplierText) {
            this.removeChild(this.multiplierText);
            this.multiplierText.destroy();
        }
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }

    public addSymbolMultiplier(): void {
        if (this.multiplierText) {
            this.removeSymbolMultiplier();
        }

        this.multiplierText = new PIXI.BitmapText("", {
            fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
            fontSize: 15,
            letterSpacing: -35
        });
        this.addChild(this.multiplierText);
        this.multiplierText.position.set(0, 0);
        this.multiplierText.anchor = new PIXI.Point(0.5, 0.5);
        this.multiplierText.alpha = 0;
        this.updateSymbolMultiplier(this.symSize);
    }

    public updateSymbolMultiplier(value: number): void {
        this.multiplierText.text = `x${value}`;
        this.multiplierText.visible = value >= 1;
        this.multiplierText.maxWidth = 30;
        //this.symSize = value;
    }

    public removeSymbolMultiplier(): void {
        this.removeChild(this.multiplierText);
    }

    public showWaysIncrease(ways: number): gsap.core.Timeline {
        const countupTl: gsap.core.Timeline = gsap.timeline();
        this.symSize = this.symSize + ways;
        countupTl.to(this.multiplierText, {alpha: 1, duration: 0.3});
        countupTl.add(() => {
            let currentValueOfMultiplier: number = parseInt(this.multiplierText.text.slice(1, this.multiplierText.text.length));
            this.updateSymbolMultiplier(currentValueOfMultiplier + ways);
        }, 0);
        // countupTl.to(this.multiplierText.scale, {x: 1, y: 1, duration: 0.3}, "<");
        // countupTl.to(this.multiplierText,{alpha:0,duration:0.2},"<");
        return countupTl;
    }

    public multiFadeOutAnim(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this.multiplierText.scale, {x: 1.5, y: 1.5, duration: 0.6});
        tl.to(this.multiplierText, {alpha: 0, duration: 0.6}, "<");
        return tl;
    }
    protected addSpine(): void {
        if (this._spine) {
            return;
        }
        this._spineContainer=new PIXI.Container();
        this._bg=new PIXI.Sprite(HTH.assetLoader.getTextures("RW/RW_BG")[0]);
        this._bg.anchor.set(0.5,0.5);
        this._frame=new PIXI.Sprite(HTH.assetLoader.getTextures("Frames/Frame")[0]);
        this._frame.anchor.set(0.5,0.5);
        this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("RW"));
        this._spine.state.setAnimation(0, "idle", false);
        // this._spine = new PIXI.Sprite(HTH.assetLoader.getTextures("RW/RW")[0]);
        // this._spine.anchor.set(0.5, 0.5);
        this.addChild(this._spineContainer);
        this._spineContainer.addChild(this._bg,this._frame,this._spine);
    }


}